<template>
  <div id="dev-component">
    Classroom Stat: {{ getClassroomId() }}
    <component :is="'production'" dev v-bind="{ devData }" :classroomId="classroomId" />

    <!-- Examples -->
    <div class="vx-row">

      <!-- Sale Stats -->
      <!-- <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Sales Stats" subtitle="Last 6 Months">
          <template slot="actions">
            <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div class="flex">
            <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>Sales</span></span>
            <span class="flex items-center ml-4"><div class="h-3 w-3 rounded-full mr-1 bg-success"></div><span>Visits</span></span>
          </div>
          <div slot="no-body-bottom">
            <vue-apex-charts type=radar height=385 :options="analyticsData.statisticsRadar.chartOptions" :series="salesRadar.series" />
          </div>
        </vx-card>
      </div> -->
        
      <!-- Activity Timeline -->
      <!-- <div class="vx-col w-full lg:w-2/3 mb-base">
        <vx-card title="Activity Timeline">
          <vx-timeline :data="timelineData" />
        </vx-card>
      </div> -->
    </div>

    <!-- Examples -->
    <div class="vx-row">
        
      <!-- Activity Timeline -->
      <!-- <div class="vx-col w-full lg:w-full mb-base">
        <vx-card title="ช่วงเวลาการเข้าเรียนของนิสิต">
          <div class="pl-10 w-full">          
            <vue-apex-charts type=heatmap height=140 :options="heatmapSum.chartOptions" :series="heatmapSum.series" />
          </div>
          <div class="w-full">
            <vue-apex-charts type=heatmap height=500 :options="heatmap.chartOptions" :series="heatmap.series" />
          </div>
        </vx-card>
      </div> -->
    </div>
  </div>
</template>

<script>
// import Axios from "@/developing/axios";
// import VueApexCharts from "vue-apexcharts";
// import VxTimeline from "@/components/timeline/VxTimeline";
import { state } from "./data";

import analyticsData from "@/developing/mocks/data/analytics.js";

import _color from '@/assets/utils/color.js'

const maxLimitOfChart = 20;
const maxLimit = 100;
const division = 4;

export default {
  components: {
    Production: () => import("./index"),
    // VueApexCharts,
    // VxTimeline
  },
  data() {
    // function generateHeatmapOptions() {
    //   return {
    //     low: {
    //       rangeFrom: 0,
    //       rangeTo: 25,
    //       name: "Low",
    //       color: "#CCCCCC"
    //     },
    //   }
    // }
    // const heatmap = generateHeatmapOptions();
    // const heatmapColorScale = {
    //   from: heatmap.low.rangeFrom,
    //   to: heatmap.low.rangeTo,
    //   name: heatmap.low.name,
    //   color: heatmap.low.color
    // };

    return {
      mockClassRoomId: "ckbnlg0knfpw20767zxyxp9l9",
      local: state,
      devData: {
        totalStudent: {
          total: 100,
          chartOptions: {
            grid: {
              show: false,
              padding: {
                left: 0,
                right: 0
              }
            },
            chart: {
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth',
              width: 2.5
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 0.9,
                opacityFrom: 0.5,
                opacityTo: 0.2,
                stops: [0, 80, 100]
              }
            },
            xaxis: {
              type: 'numeric',
              lines: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              labels: { show: false }
            },
            yaxis: [{
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 },
            }],
            tooltip: {
              enabled: false,
              x: { show: false }
            },
            theme: {
              monochrome: {
                enabled: true,
                color: getHex('warning'),
                shadeTo: 'light',
                shadeIntensity: 0.65
              }
            }
          },
          chartSeries: [
            {
              name: 'Subscribers',
              data: [28, 40, 36, 52, 38, 60, 55]
            }
          ],
        }
      },
      hideChart: false,
      iconRight: true,
      timelineData: [
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Client Meeting",
          desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
          time: "25 mins Ago"
        },
        {
          color: "warning",
          icon: "MailIcon",
          title: "Email Newsletter",
          desc: "Cupcake gummi bears soufflé caramels candy",
          time: "15 Days Ago"
        },
        {
          color: "danger",
          icon: "UsersIcon",
          title: "Plan Webinar",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 days ago"
        },
        {
          color: "success",
          icon: "LayoutIcon",
          title: "Launch Website",
          desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.",
          time: "25 days ago"
        },
        {
          color: "primary",
          icon: "TvIcon",
          title: "Marketing",
          desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.",
          time: "28 days ago"
        }
      ],
      analyticsData,
      salesRadar: {},
      unitStats: {
        series: [
          {
            name: '',
            data: generateData(maxLimitOfChart, {
              min: -999999,
              max: -999999
            })
          },
          {
            name: 'X0001',
            // data: [
            //   {
            //     x: "1",
            //     y: "1"
            //   }
            // ],
            data: generateData(maxLimitOfChart, {
              min: 0,
              max: 100
            })
          },
        ],
        chartOptions: {
          title: {
            text: 'HeatMap Chart with Color Range'
          },
          chart: {
            height: 350,
            type: 'heatmap',
          },
          plotOptions: {
            heatmap: {
              shadeIntensity: 0.5,
              radius: 1,
              useFillColorAsStroke: false,
              colorScale: {
                ranges: [
                  {
                    from: -1000000,
                    to: -999999,
                    name: 'hidden',
                    color: '#ffffff'
                  },
                  {
                    from: 1,
                    to: maxLimit / division * 1,
                    name: 'low',
                    color: '#dddddd'
                  },
                  {
                    from: 26,
                    to: maxLimit / division * 2,
                    name: 'medium',
                    color: '#bbbbbb'
                  },
                  {
                    from: 51,
                    to: maxLimit / division * 3,
                    name: 'high',
                    color: '#aaaaaa'
                  },
                  {
                    from: 76,
                    to: maxLimit,
                    name: 'very high',
                    color: '#7367f0'
                  }
                ]
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          stroke: {
            width: 2
          },
        },
      },
      heatmap: {
        series: [
          {
            name: 'อาทิตย์ ',
            data: generateData(24, {
              min: 0,
              max: 100
            })
          },
          {
            name: 'เสาร์ ',
            data: generateData(24, {
              min: 0,
              max: 100
            })
          },
          {
            name: 'ศุกร์ ',
            data: generateData(24, {
              min: 0,
              max: 100
            })
          },
          {
            name: 'พฤหัสฯ ',
            data: generateData(24, {
              min: 0,
              max: 100
            })
          },
          {
            name: 'พุธ ',
            data: generateData(24, {
              min: 0,
              max: 100
            })
          },
          {
            name: 'อังคาร ',
            data: generateData(24, {
              min: 0,
              max: 100
            })
          },
          {
            name: 'จันทร์ ',
            data: generateData(24, {
              min: 0,
              max: 100
            })
          },
        ],
        chartOptions: {
          title: {
            text: 'ข้อมูลรายสัปดาห์'
          },
          chart: {
            height: 500,
            type: 'heatmap',
          },
          plotOptions: {
            heatmap: {
              shadeIntensity: 0.8,
              radius: 0,
              useFillColorAsStroke: false,
              colorScale: {
                ranges: [
                  {
                    from: -10,
                    to: 0,
                    name: 'none',
                    color: "#999999"
                  },
                  {
                    from: 1,
                    to: 50,
                    name: 'low',
                    color: getHex("warning")
                  },
                  {
                    from: 51,
                    to: 100,
                    name: 'high',
                    color: getHex("success")
                  }
                ]
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 1
          },
        },
      },
      heatmapSum: {
        series: [
          {
            name: '',
            data: generateData(24, {
              min: 0,
              max: 55
            })
          }
        ],
        chartOptions: {
          title: {
            text: 'ข้อมูลรวม'
          },
          chart: {
            height: 600,
            type: 'heatmap',
          },
          plotOptions: {
            heatmap: {
              shadeIntensity: 0.9,
              radius: 0,
              useFillColorAsStroke: false,
              colorScale: {
                ranges: [
                  {
                    from: -10,
                    to: 0,
                    name: 'none',
                    color: "#999999"
                  },
                  {
                    from: 1,
                    to: 50,
                    name: 'low',
                    color: getHex("warning")
                  },
                  {
                    from: 51,
                    to: 100,
                    name: 'high',
                    color: getHex("success")
                  }
                ]
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: 1
          },
        },
      },
      chart: {
        chart: {
          id: "chart2",
          type: "area",
          height: 350,
          foreColor: "#ccc",
          toolbar: {
            autoSelected: "pan",
            show: false
          }
        },
        colors: [getHex("primary"), "#ddd"],
        stroke: {
          width: 3,
          curve: 'smooth'
        },
        grid: {
          borderColor: "#f9f9f9",
          clipMarkers: false,
          yaxis: {
            lines: {
              show: true
            }
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -10,
          background: {
            enabled: false,
          }
        },
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.7,
            opacityTo: 0
          }
        },
        markers: {
          size: 7,
          colors: ["#fff"],
          strokeColor: [getHex("primary"), "#ccc"],
          strokeWidth: 3
        },
        tooltip: {
          // theme: "dark"
          x: {
            formatter: function (value) {
              return "หน่วยการเรียนที่ " + value
            }, 
          }
        },
        legend: {
          show: true,
        },
        xaxis: {
          type: "category",
          labels: {
            style: {
              colors: [],
              fontSize: '1rem',
            },
            offsetY: 2,
          },
          categories: [
            "ยังไม่เริ่มต้นเรียน",
            1, 
            2, 
            3, 
            4, 
            5, 
            6, 
            7, 
            8, 
            9, 
            10,
            11,
            12,
            13,
            14,
            15
          ]
        },
        yaxis: {
          min: 0,
          tickAmount: 4
        }
      },
      chartSeries: [
        {
          name: 'ปัจจุบัน',
          data: [0, 31, 40, 28, 51, 42, 109, 100, 24, 43, 12, 14, 53, 12]
        },
        {
          name: 'ก่อนหน้า',
          data: [100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ]
    }
  },
  props: {
    classroomId: {
      type: String,
      default: null
    }
  },
  methods: {
    getClassroomId() {
      if (this.classroomId) return this.classroomId;
      else if (this.mockClassroomId) return this.mockClassroomId;
    }
  },
  mounted() {
    state.classroomId = this.getClassroomId();
  }
}

function getHex(color) {
  if (_color.isColor(color)) {
    let rgb  = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${color}`);
    rgb = rgb.split(",");
    return "#" + ((1 << 24) + (Number(rgb[0]) << 16) + (Number(rgb[1]) << 8) + Number(rgb[2])).toString(16).slice(1);
  }
  return color
}

function generateData(count, yrange) {
  var i = 0;
  var series = [];
  while (i < count) {
    // var x = (i + 1).toString();
    const x = (i < 17 ? (i + 7).toString() : (i - 17).toString()) + ":00" ;
    var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

    series.push({
      x: x,
      y: y
    });
    i++;
  }
  return series;
}
</script>
